import { jsx as _jsx } from "react/jsx-runtime";
import invariant from 'tiny-invariant';
import { condenseAddress } from '../../utils/addresses.js';
import { cn } from '../../utils/classnames.js';
const MIN_CONDENSED_LENGTH = 8;
const MAX_CONDENSED_LENGTH_VARIANCE = 4; // How much the lengthier condensed address can vary from the actual length.
function Address({ address, className, dataTestId, length, condensed = false, }) {
    invariant(length === undefined || length >= MIN_CONDENSED_LENGTH, `Address: \`length\` must be greater than or equal to ${MIN_CONDENSED_LENGTH}`);
    const maxCondensedLength = address.length - MAX_CONDENSED_LENGTH_VARIANCE;
    invariant(length === undefined || length < maxCondensedLength, `Address: \`length\` must be less than ${maxCondensedLength} for address '${address}'`);
    const shouldCondense = condensed || length !== undefined;
    return (_jsx("code", { title: shouldCondense ? address : undefined, className: cn('ui-whitespace-pre-wrap ui-break-words ui-break-all ui-font-mono ui-text-sm ui-font-medium ui-text-black theme-dark:ui-text-white', className), "data-testid": dataTestId, children: shouldCondense ? condenseAddress(address, length ?? 10) : address }));
}
export default Address;
